// extracted by mini-css-extract-plugin
export default {"dropdownIcon":"_mQPaTDhi4y5yqCbHJqJ","dropdownTitle":"ORyNSantfKr1raQCi6HF"};